import { AltriSoggettiGiudiziarioDTO } from "./altri-soggetti-giudiziario-dto";
import { AutoritaOrdinanteDTO } from "./autorita-ordinante-dto";
import { DatiDepositoGiudiziarioDTO } from "./dati-deposito-giudiziario-dto";

export class CostituzioneDepositoGiudiziarioDTO {
	altriSoggetti: AltriSoggettiGiudiziarioDTO;
	autoritaOrdinante: AutoritaOrdinanteDTO;
	datiDeposito: DatiDepositoGiudiziarioDTO;
}